<template>
  <div class="container mx-auto p-4 max-w-4xl">
    <h1 class="text-3xl font-bold mb-8 text-gray-800">
      <i class="fas fa-file-contract mr-2 text-primary"></i>
      用户服务条款
    </h1>

    <div class="space-y-8 text-gray-700">
      <section class="card p-6 bg-white rounded-xl shadow-sm">
        <h2 class="text-xl font-semibold mb-4 text-gray-800">解释和定义</h2>
        <div class="space-y-4">
          <p class="font-medium">就本条款而言：</p>
          <ul class="list-disc pl-6 space-y-2">
            <li><strong>服务：</strong>指喵记笔记提供的笔记和复习服务。</li>
            <li><strong>设备：</strong>指可以访问服务的任何设备，如计算机、手机或数字平板。</li>
            <li><strong>用户：</strong>指访问或使用服务的个人。</li>
            <li><strong>网站：</strong>指从我们的域名访问的喵记笔记网站。</li>
          </ul>
        </div>
      </section>

      <section class="card p-6 bg-white rounded-xl shadow-sm">
        <h2 class="text-xl font-semibold mb-4 text-gray-800">用户须知</h2>
        <div class="space-y-4">
          <p>本条款明确了使用此服务的使用规范。这些条款明确了所有用户在使用服务时的权利和责任。</p>
          <p>通过访问或使用服务，您同意受这些条款的约束。如果您不同意这些条款的任何部分，则您可以选择不使用服务。</p>
          <p>您对服务的访问和使用还取决于您接受并遵守公司的隐私政策。请在使用我们的服务之前，仔细阅读我们的隐私政策。</p>
        </div>
      </section>

      <section class="card p-6 bg-white rounded-xl shadow-sm">
        <h2 class="text-xl font-semibold mb-4 text-gray-800">用户责任</h2>
        <div class="space-y-4">
          <ul class="list-disc pl-6 space-y-2">
            <li>遵守相关法律法规，不得利用本服务从事违法活动</li>
            <li>保护账号安全，不与他人分享账号</li>
            <li>对自己发布的内容负责，确保内容合法合规</li>
            <li>尊重其他用户的权利，不得进行骚扰或侵犯行为</li>
            <li>不得滥用或破坏系统，包括但不限于使用自动化工具</li>
          </ul>
        </div>
      </section>

      <section class="card p-6 bg-white rounded-xl shadow-sm">
        <h2 class="text-xl font-semibold mb-4 text-gray-800">终止</h2>
        <div class="space-y-4">
          <p>我们可以立即终止或暂停您的访问权限，无需事先通知或承担责任，特别是在以下情况：</p>
          <ul class="list-disc pl-6 space-y-2">
            <li>违反本服务条款</li>
            <li>涉嫌违法或滥用行为</li>
            <li>其他我们认为需要终止服务的情况</li>
          </ul>
        </div>
      </section>

      <section class="card p-6 bg-white rounded-xl shadow-sm">
        <h2 class="text-xl font-semibold mb-4 text-gray-800">免责声明</h2>
        <div class="space-y-4">
          <p>服务是按"现状"和"可用"基础提供给您的，这意味着：</p>
          <ul class="list-disc pl-6 space-y-2">
            <li>我们不保证服务永远不会中断或无错误</li>
            <li>我们不对服务的及时性、安全性或可靠性作出保证</li>
            <li>用户需要对使用本服务的风险自行承担责任</li>
          </ul>
        </div>
      </section>

      <section class="card p-6 bg-white rounded-xl shadow-sm">
        <h2 class="text-xl font-semibold mb-4 text-gray-800">条款变更</h2>
        <div class="space-y-4">
          <p>我们保留随时修改这些条款的权利。如果修订内容重大，我们将提前通知。继续使用服务即表示您接受新的条款。</p>
        </div>
      </section>

      <section class="text-sm text-gray-500 mt-8">
        <p>最后更新时间：2024年03月01日</p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsView'
}
</script> 